import TenantError from './tenant-error.vue';

export default TenantError;
